if (!customElements.get('juki-purchase-row')) {
  customElements.define('juki-purchase-row', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-juki-direct-purchase]');
      this.form = document.getElementById(this.dataset.formId);
      this.source = this.form?.querySelector('button[name="add"]');
      if (!this.source) return;
      this.sync = () => {
        this.button.disabled = this.source.disabled;
        const label = this.source.querySelector('.btn-label');
        if(label && !this.source.disabled && label.textContent.trim() !== this.button.textContent.trim()) label.textContent = this.button.textContent.trim();
        const input = this.closest('.shopify-section').querySelector('.juki-payment-terms input[name="id"]');
        const variant = this.form.querySelector('input[name="id"]');
        if (input && variant && input.value !== variant.value) {input.value = variant.value;input.dispatchEvent(new Event('change', {bubbles:true}));}
      };
      this.buy = () => this.source.click();
      this.button.addEventListener('click',this.buy);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.form,{attributes:true,subtree:true,attributeFilter:['disabled','value']});
      this.form.addEventListener('change',this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click',this.buy);
      this.form?.removeEventListener('change',this.sync);
    }
  });
}

if(!customElements.get('juki-klarna')) customElements.define('juki-klarna',class extends HTMLElement{connectedCallback(){this.dialog=this.querySelector('dialog');this.open=()=>this.dialog.showModal();this.close=()=>this.dialog.close();this.querySelector('button').addEventListener('click',this.open);this.querySelector('[data-close]').addEventListener('click',this.close)}disconnectedCallback(){this.querySelector('button')?.removeEventListener('click',this.open);this.querySelector('[data-close]')?.removeEventListener('click',this.close)}});
